/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { cn } from '@express-labs/raven-tools';
import { Button } from '@express-labs/raven-ui';

import routes from '../../../../../routes/routes';
import s from './BagPeekHeader.module.scss';

function BagPeekHeader({ bagCount, subtotal, className }) {
  const handleClick = () => {
    window.location.assign(routes.bag.path);
  };

  return (
    <div className={cn(s.container, className)}>
      <div className={s.topPanel}>
        <span aria-label="bag count" className={cn('bagPeekBagCount', 'bodySecondary')}>
          {bagCount}
          {' '}
          items
        </span>
        <span aria-label="subTotal" className={cn('bagPeekBagSubtotal', 'bodySecondary')}>
          Subtotal:
          {' '}
          <b>{`$${parseFloat(Math.round(subtotal * 100) / 100).toFixed(2)}`}</b>
        </span>
      </div>
      <Button className={s.checkoutBtn} onClick={handleClick} aria-label="check out">
        View Bag & Check Out
      </Button>
    </div>
  );
}

BagPeekHeader.propTypes = {
  bagCount: PropTypes.number,
  className: PropTypes.string,
  subtotal: PropTypes.string,
};

export default BagPeekHeader;
